
/**
 * Convert object from an array of field keys and array of field values
 * @param fields 
 * @param row 
 * @returns 
 */
export function getFieldValues(fields: string[], row: any[]): Record<string, any> {
    const ret = {};
    fields.forEach((item, idx) => {
        ret[ item ] = row[ idx ];
    });
    return ret;
}